import { render, staticRenderFns } from "./ViewOrder.vue?vue&type=template&id=6d2c9afa&scoped=true"
import script from "./ViewOrder.vue?vue&type=script&lang=ts"
export * from "./ViewOrder.vue?vue&type=script&lang=ts"
import style0 from "./ViewOrder.vue?vue&type=style&index=0&id=6d2c9afa&prod&lang=scss&scoped=true"
import style1 from "./ViewOrder.vue?vue&type=style&index=1&id=6d2c9afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2c9afa",
  null
  
)

export default component.exports